// extracted by mini-css-extract-plugin
export default {"pageLayout":"_-z","mainContent":"aa-z","activeSidebar":"ba-z"};